<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <card-header title="Create Device">
              <base-button type="white" size="sm" @click="onCancel"
                >Cancel</base-button
              >
              <base-button
                type="success"
                size="sm"
                native-type="submit"
                :loading="isLoading"
                >Create</base-button
              >
            </card-header>

            <b-card-body>
              <b-row>
                <b-col md="6">
                  <base-input
                    label="Device ID"
                    name="name"
                    v-model="form.name"
                    :rules="{ required: true, devicename: true }"
                  />
                </b-col>
                <b-col md="6">
                  <base-input
                    label="Description"
                    name="description"
                    v-model="form.description"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <fieldset>
                    <label class="form-control-label"
                      >Groups
                      <span class="font-weight-light">Optional</span></label
                    >
                    <dispenser-select :selected.sync="form.group" />
                  </fieldset>
                </b-col>
              </b-row>

              <!--b-row>
                <b-col md="3">
                  <base-input label="Lora DevEUI" name="lora_deveui" v-model="form.lora_deveui" :rules="{lora_deveui: true}" />
                </b-col>

                <b-col md="3">
                  <base-input label="LTE IMSI" name="lte_imsi" v-model="form.lte_imsi" :rules="{lte_imsi: true}" />
                </b-col>

                <b-col md="3">
                  <base-input label="Version ID" name="version" v-model="form.version_id" :rules="{}" />
                </b-col>

                  <b-col md="3">
                  <label class="form-control-label">Manufacturing Type</label>
                  <b-form-radio-group v-model="form.manufacturing_type">
                    <b-form-radio value="CC1">CC1</b-form-radio>
                    <b-form-radio value="CC2">CC2</b-form-radio>
                  </b-form-radio-group>
                                  </b-col>


              </b-row>-->

              <!--b-row>

                <b-col md="12">
                  <label class="form-control-label">X509 Certificate <span class="font-weight-light">Optional</span></label>
                  <textarea class="form-control mb-2 font-mono" rows="2" v-model="form.cert" readonly></textarea>
                  <file-loader
                      initialLabel="Select Certificate file"
                      accept=".pem,.pub"
                      :maxSize="100000"
                      :content.sync="form.cert" />
                </b-col>

              </b-row>-->
            </b-card-body>
          </b-form>
        </validation-observer>
      </b-card>
    </b-container>
  </div>
</template>

<!-- ###################################################################### -->

<script>
import { Routes } from "@/router";
import { Action } from "@/store/actions";
import FileLoader from "@/views/components/FileLoader";
import { MapServiceDevice } from "@/services/map.service";
import DispenserSelect from "../../views/components/DispenserSelect.vue";

export default {
  name: "DeviceNew",
  components: {
    FileLoader,
    DispenserSelect,
  },
  data() {
    return {
      form: {
        name: "",
        description: "",
        manufacturing_type: "CC1",
        lora_deveui: "", // mac_1
        lte_imsi: "", // mac_2
        version_id: "",
        group: "",
        dispenser: undefined,
        cert: undefined,
      },
      isLoading: false,
    };
  },
  methods: {
    onCancel() {
      this.$router.push({ name: Routes.deviceList });
    },
    onSubmit() {
      this.isLoading = true;
      this.fillGPS();
  //    console.log(this.form);
      this.$store
        .dispatch(Action.device.add, MapServiceDevice.formToModel(this.form))
        .then(() => {
          this.$router.push({ name: Routes.deviceList });
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error);
        });
    },
    fillGPS() {
      if (!this.form.site) return;
      const siteObj = this.$store.getters.siteByName(this.form.site);
      if (!this.form.latitude) {
        this.form.latitude = siteObj.gps_coordinates.coordinates[0];
      }
      if (!this.form.longitude) {
        this.form.longitude = siteObj.gps_coordinates.coordinates[1];
      }
    },
  },
};
</script>
